module.exports = __webpack_public_path__ + "static/media/tidal-close.2c79abb5.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/promos/tidal/tidal-close.svg
// module id = 1313
// module chunks = 0